class FloatingBackToTop {
  constructor(options) {
    this.options = Object.assign({ showAfter: 400 }, options);
    this.button = document.getElementById('floating-back-to-top');
    if (!this.button) return;

    this.ticking = false;
    this.bindScroll();
    this.bindClick();
    this.updateVisibility();
  }

  bindScroll() {
    window.addEventListener('scroll', () => {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.updateVisibility();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }, { passive: true });
  }

  updateVisibility() {
    const scrolled = window.scrollY || document.documentElement.scrollTop;
    this.button.classList.toggle('is-visible', scrolled > this.options.showAfter);
  }

  bindClick() {
    this.button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
}

window.FloatingBackToTop = FloatingBackToTop;
